<template>
<div class="mr15">
  <sui-page-contents>
    <sui-jqx-grid ref="grid" :columns="gridColumns0" width="100%" :dataset="'dataset0'" :sortable="true" :rowsheight="40" scrollbarsize="0" columnsresize="enable"/>
    <!-- Search Box -->
    <sui-page-tab-box-type
      ref="tab"
      :tabItems="tabItems"
      :defaultTabIndex="defaultTabIndex"
      :setCurrentTabComponent="setCurrentTabComponent"
      @change-tab-idx="tabSelected"
    >
      <container :is="currentTabComponent"/>
    </sui-page-tab-box-type>
  </sui-page-contents>
</div>
</template>
<script>

import LangSelect from '~common/components/form/SuiLangSelect/SuiLangSelect';
import t01 from "./Sample_GridParentDataset_T";

export default {
  name: 'DatasetWithComponent',
  components: {
    t01,
  },
  data() {
    return {
      defaultTabIndex: 0,
      tabItems: [
        {
          tabTitle: "tab01",
          tabSubTitle: "sub01",
          component: "t01" // pageID
        },
      ],
      currentTabComponent: null,
      tabIndex: 0,
      multiSelectOptions: [
        {key:'m1', label:'aulti1',},
        {key:'m2', label:'bulti2',},
        {key:'m2', label:'culti3',},
        {key:'m2', label:'dulti4',},
      ],
      multiSelected: [],
      selectedUser: {
        userName: '',
        epid: '',
      },
      rangeDate: { start: "2019-11-10", end: '2019-11-15' },
      pageUsePriodStartDatetime: new Date(),
      // pageUsePriodStartDatetime: "2000-01-01",
      pageUsePriodFinishDatetime: "2100-10-10",
      cellEditorMap: {},
      customOpitonList: [{
        key: '',
        label: 'AAA'
      }, ],
      selected: {
        md: {
          key: '',
          label: ''
        },
        smd: {
          key: '',
          label: ''
        },
        code: {
          key: '',
          label: ''
        },
        lang: {
          key: '',
          label: ''
        },
        yn: {
          key: '',
          label: ''
        },
        custom: {
          key: '개발',
          label: ''
        },
        customlang: {
          key: '',
          label: ''
        },
      },
      customOptions: [{
          key: 'D',
          label: '개발'
        },
        {
          key: 'F',
          label: '완료'
        },
      ],
      mdDisabled: false,
      pageName: '',
      pagePopupYn: '',
      checked: false,
      gridColumns0: [{
        text: '모듈',
        datafield: 'moduleCode',
        width: 90
      }, {
        text: '서브모듈',
        datafield: 'subModuleCode'
      }, {
        text: '페이지유형',
        datafield: 'pageTypeCode',
        cellsalign: 'center'
      }, {
        text: '페이지 ID',
        datafield: 'pageId'
      }, {
        text: '페이지 명',
        datafield: 'pageName',
        createwidget: (row, column, value, htmlElement) => {
          const editorInstance = utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
            trim: true,
          }, this.dataset0);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: '페이지 상태',
        datafield: 'pageStatusCode',
        createwidget: (row, column, value, htmlElement) => {
          const editorInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
            optionList: this.customOptions,
          }, this.dataset0);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: '사용여부',
        datafield: 'pageUseYn',
        $component: this,
        createwidget: (row, column, value, htmlElement) => {
          const editorInstance = utils.getGridCellFactory().createCellRadioGroup(row, column, value, htmlElement, {
            items: [{key: 'Y', label: 'Yes'}, {key: 'N', label: 'No'}],
          }, this.dataset0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: '수정자',
        datafield: 'finalModificationUserId'
      }, {
        text: '수정일시',
        datafield: 'finalModificationDTM',
        $component: this,
        createwidget(row, column, value, htmlElement) {
          // console.log(this.$component);
          // const targetData = this.dataset0.data;
          // const editorComponent = utils.getGridCellFactory().createCellDatePicker(row, column, value, htmlElement, this.dataset0);
        },
        initwidget(row, column, value, htmlElement) {
          // console.log(this.$component);
        },
      }],
      localdata0: [{
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00000",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": moment("2019-05-10"),
          "pageUsePriodFinishDatetime": "9999-12-31",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': { start: "2019-01-10", end: '2019-02-15' },
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00003",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00003",
          "pageId": "PGE_CMS_00001",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "N",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': { start: "2019-02-10", end: '2019-02-15' },
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00005",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00005",
          "pageId": "PGE_CMS_00002",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': { start: "2019-03-10", end: '2019-03-15' },
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00002",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00002",
          "pageId": "PGE_CMS_00003",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "N",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
          'rangeDate': '2019-07-10~2019-07-15',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00004",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00004",
          "pageId": "PGE_CMS_00004",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00005",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00006",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00007",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00008",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00009",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
        {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00010",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        }, {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00011",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        }, {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00012",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        }, {
          "deleteYn": "N",
          "firstRegistrationDTM": "20190510125920",
          "firstRegistrationUserId": "chiwoo.seo",
          "firstRegistrationProgramId": "PGE_CMU_00001",
          "finalModificationDTM": "2019-05-10 12:59:20",
          "finalModificationUserId": "chiwoo.seo",
          "finalModificationProgramId": "PGE_CMU_00001",
          "pageId": "PGE_CMS_00013",
          "moduleCode": "CM",
          "subModuleCode": "S",
          "pageName": "배치작업이력",
          "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
          "pageTypeCode": "N",
          "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
          "pageStatusCode": "D",
          "pageBlockContent": "차단된 페이지입니다.",
          "pageUseYn": "Y",
          "pageUsePriodYn": "N",
          "pageUsePriodStartDatetime": "20190510125916",
          "pageUsePriodFinishDatetime": "99991231235959",
          "pagePopupYn": "N",
          "pagePopupOptionValue": null,
          "searchPageCond": null,
          "searchPageText": null,
          "lang": 'en',
        },
      ],
    };
  },
  mounted() {
    console.log(moment("2019-05-10"));
    // this.dataset0.$on(this.dataset0.EVENTS.DATA_CHANGED, this.datasetUpdate);
    // this.dataset0.$on(this.dataset0.EVENTS.DATAFIELDS_CHANGED, this.datasetUpdate);
    // this.dataset0.$on(this.dataset0.EVENTS.RAW_DATA_CHANGED, this.datasetUpdate);
  },
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
        "name": "deleteYn",
        "type": "string",
        "map": "deleteYn"
      },
      {
        "name": "firstRegistrationDTM",
        "type": "string",
        "map": "firstRegistrationDTM"
      },
      {
        "name": "firstRegistrationUserId",
        "type": "string",
        "map": "firstRegistrationUserId"
      },
      {
        "name": "firstRegistrationProgramId",
        "type": "string",
        "map": "firstRegistrationProgramId"
      },
      {
        "name": "finalModificationDTM",
        "type": "string",
        "map": "finalModificationDTM"
      },
      {
        "name": "finalModificationUserId",
        "type": "string",
        "map": "finalModificationUserId"
      },
      {
        "name": "finalModificationProgramId",
        "type": "string",
        "map": "finalModificationProgramId"
      },
      {
        "name": "pageId",
        "type": "string",
        "map": "pageId"
      },
      {
        "name": "moduleCode",
        "type": "string",
        "map": "moduleCode"
      },
      {
        "name": "subModuleCode",
        "type": "string",
        "map": "subModuleCode"
      },
      {
        "name": "pageName",
        "type": "string",
        "map": "pageName"
      },
      {
        "name": "pageTitleMessageResourceId",
        "type": "string",
        "map": "pageTitleMessageResourceId"
      },
      {
        "name": "pageTypeCode",
        "type": "string",
        "map": "pageTypeCode"
      },
      {
        "name": "pageDestinationValue",
        "type": "string",
        "map": "pageDestinationValue"
      },
      {
        "name": "pageStatusCode",
        "type": "string",
        "map": "pageStatusCode"
      },
      {
        "name": "pageBlockContent",
        "type": "string",
        "map": "pageBlockContent"
      },
      {
        "name": "pageUseYn",
        "type": "string",
        "map": "pageUseYn"
      },
      {
        "name": "pageUsePriodYn",
        "type": "string",
        "map": "pageUsePriodYn"
      },
      {
        "name": "pageUsePriodStartDatetime",
        "type": "string",
        "map": "pageUsePriodStartDatetime"
      },
      {
        "name": "pageUsePriodFinishDatetime",
        "type": "string",
        "map": "pageUsePriodFinishDatetime"
      },
      {
        "name": "pagePopupYn",
        "type": "string",
        "map": "pagePopupYn"
      },
      {
        "name": "pagePopupOptionValue",
        "type": "string",
        "map": "pagePopupOptionValue"
      },
      {
        "name": "searchPageCond",
        "type": "string",
        "map": "searchPageCond"
      },
      {
        "name": "searchPageText",
        "type": "string",
        "map": "searchPageText"
      },
      {
        "name": "lang",
        "type": "string",
        "map": "lang"
      },
      {
        "name": "rangeDate",
        "type": "string",
        "map": "rangeDate"
      },
    ]
  }],
  methods: {
    onClicked() {},
    onCodeLoaded(optionsList) {
      optionsList.push({
        key: 'N',
        label: 'NN'
      });
    },
    datasetUpdate() {
      console.log('update');
    },
    onTestClicked() {
      this.dataset0.data[0]['pageId'] = 'TEST';
    },
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
  }
};
</script>
